import VxeFormComponent from './src/form';
import { dynamicApp } from '../dynamics';
export var VxeForm = Object.assign(VxeFormComponent, {
    install: function (app) {
        app.component(VxeFormComponent.name, VxeFormComponent);
    }
});
export var Form = VxeForm;
dynamicApp.component(VxeFormComponent.name, VxeFormComponent);
export default VxeForm;
